/**
* author: duxin
* date: 2020/4/7
* describe:
*/

<template>
  <footer class="footer-wrap">
    <div class="content">
      <div class="left">
        <img src="../assets/foot_logo.png" alt="" />
        <p>{{ $t("common.companyNameAll") }}</p>
        <p>{{ $t("footer.tel") }}</p>
        <p>{{ $t("footer.fax") }}</p>
        <p>{{ $t("footer.email") }}</p>
        <!--<p>{{$t('footer.web')}}</p>-->
        <p>{{ $t("footer.address") }}</p>
        <p>{{ $t("footer.code") }}</p>
      </div>
      <div class="right">
        <img src="../assets/foot_code_1.jpg" alt="" />
        <img src="../assets/foot_code_2.png" alt="" />
        <img src="../assets/foot_code_3.png" alt="" />
      </div>
    </div>
    <div class="company">
      <p>
        {{ $t("footer.company") }} <br />
        <!-- <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502047871"
          style="color: #fff"
          ><img src="../assets/national_emblem.png" style="vertical-align: sub;" /> 京公网安备
          11010502047871号</a
        >
        &nbsp; -->
        <a
          href="https://beian.miit.gov.cn"
          target="_blank"
          style="color: #fff"
          >{{ $t("footer.compangCode") }}</a
        >
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "kllk-footer-nav",
};
</script>

<style lang="less" scoped>
@import "../style/constant";

.footer-wrap {
  background-color: @primary-color;
  color: white;
  padding: 50px;
  .content {
    max-width: @page-width;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    .left {
      p {
        line-height: 30px;
      }

      img {
        width: 300px;
      }
    }

    .right {
      min-width: 570px;

      img {
        width: 140px;
        height: 140px;
        object-fit: cover;
        margin: 0 30px;

        &:nth-child(3) {
          margin-right: 0;
        }
      }
    }
  }

  .company {
    max-width: @page-width;
    margin: 50px auto 0;
    padding-top: 50px;
    border-top: 1px solid #b9b9b9;
    text-align: center;
  }

  @media screen and (min-width: 320px) and (max-width: 480px) {
    .content {
      display: inline-block !important;
      .right {
        text-align: center;
        margin-top: 30px;
        min-width: 100% !important;

        img {
          height: 155px;
          width: 155px;
          margin: 15px;
          display: inline-block !important;
          &:nth-child(3) {
            margin-right: 15px;
          }
        }
      }
    }
  }
}
</style>
